// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\EnumType.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumItemMD } from '../../../../../../libs/com/MetaPattern/MDA/MD/EnumItemMD';

/**
 * 组件类型枚举 枚举类
 * 组件类型枚举
 */
export enum EnumComponentType {
  /** 应用组件 : 应用组件 */
  APP = 1,
  /** 业务实体组件 : 业务实体组件 */
  BE = 2,
  /** 数据库组件 : 数据库组件 */
  DB = 4,
  /** 产品组件 : 产品组件 */
  Product = 8,
  /** 界面模型组件 : 界面模型组件 */
  UIModel = 16
}

/**
 * 组件类型枚举 枚举元数据类
 * 获取枚举的元数据信息：名称、显示名称、描述、值
 */
export class EnumComponentTypeMD {
  private static items = [
    new EnumItemMD('APP', 1, '应用组件', '应用组件'),
    new EnumItemMD('BE', 2, '业务实体组件', '业务实体组件'),
    new EnumItemMD('DB', 4, '数据库组件', '数据库组件'),
    new EnumItemMD('Product', 8, '产品组件', '产品组件'),
    new EnumItemMD('UIModel', 16, '界面模型组件', '界面模型组件')
  ];

  static getItem(enumItem: EnumComponentType) {
    return this.items.find(item => item.name === EnumComponentType[enumItem]);
  }

  static getItemByName(enumItemName: string) {
    return this.items.find(item => item.name === enumItemName);
  }

  static getItemByValue(enumItemValue: number) {
    return this.items.find(item => item.value === enumItemValue);
  }

  static getItems() {
    return this.items;
  }
}
